
<p-inc-todo-card
    :item = "item"
>
    <template v-slot:comment>
        <div class="v-flex">
            <div class="card-subtitle status-line">
                <span>
                    {{ dateAsString (item.nextAssessment) }}
                </span>
                <span class="ml-1 warning--text" v-if="item.dateScheduled">
                    ZÜS Prüfung geplant für {{ dateAsString (item.dateScheduled) }}
                </span>
            </div>
            <v-spacer/>
            <div class="card-subtitle" :class="textColor()" v-if="item.begin && !future">
                {{ delay }} Tage
            </div>
        </div>
    </template>
</p-inc-todo-card>